import { defineComponent } from 'vue';
import axios, { AxiosResponse } from 'axios';
import * as bootstrap from "bootstrap";
import { LandingPageIDViewModel } from "./../../Scripts/js/ViewModel/LandingPageIDViewModel";

export class dccore_configblobview {
    public idnum: number = 0;
    public idmember: number = 0;
    public hashid: string = "";
    public emp: number = 0;
    public idsession: string = "";
    public external: boolean = false;
    public hostname: string = "";
    public md5hostname: string = "";
    public ispublish: boolean = false;
    public datesnapshot!: Date;
    public first: boolean = false;
}

export class dccoreview_monitorconf {
    public idnum: number = 0;
    public idmember: number = 0;
    public idsession: string | null = "";
    public hostname: string = "";
    public md5hostname: string = "";
    public expiration: Date | null = null;
    public datecreate: Date | null = null;
    public hashid: string = "";
}


export class dccore_configseoview {
    public  idconfiguser: number = 0;
    public  page: number = 0;
    public  keywords: string = "";
    }

export class GroupeConfigBlobView {
    public emp: number = 0;
    public blobs: dccore_configblobview[] = [];
}



export class ConfigurationViewModel {
    public blobsmon: dccoreview_monitorconf[] = [];
    public blobs: GroupeConfigBlobView[] = [];
    public blobsseo: dccore_configseoview[] = [];
    public lastconfigicon: string = "";
    public  lastconfigname: string = "";
    public lastconfigurl: string = "";
    public lastconfighostname: string = "";
}

export class MonitoringConfigurationViewModel {
    public idnum: number = 0;
    public idmember: number = 0;
    public hostname: string = "";
    public md5hostname: string = "";
    public hashid: string = "";
    public datesnapshot: Date | null = null;
    public IsRunning: boolean = false;
}

export class GetMonitoringConfigResponse {
    public Configurations: MonitoringConfigurationViewModel[] = [];
    public LastConfigIcon: string = "";
}

declare var g_initdesc: string;
declare var g_landingpageid: number;
declare var g_lancurrent: string;
declare var g_dctoolsbackurl: string;

export const MixinConfigurationModule = defineComponent({
    data() {
        return {
            blobs: [] as GroupeConfigBlobView[],
            blobsseo: [] as dccore_configseoview[],
            configsmon: [] as MonitoringConfigurationViewModel[],
            defaultconfigdesc: "",
            landingpageid: 0,
            lancurrent: "",
            dctoolsbackurl: '',
            lastconfigname: "",
            lastconfigurl:" ",
            lastconfigicon: "",
            lastconfighostname: ""
        };
    },
   

    mounted() {
        this.defaultconfigdesc = g_initdesc;
        this.landingpageid = g_landingpageid;
        this.lancurrent = g_lancurrent;
        this.dctoolsbackurl = g_dctoolsbackurl;

        if (this.landingpageid == LandingPageIDViewModel.MONITORINGPAGE || this.landingpageid == LandingPageIDViewModel.REALTIMEMONITORINGPAGE) {
            this.LoadConfigMonitoring(this.dctoolsbackurl);
        }
        else {
            this.LoadConfig();
        }
    },
    methods: {
        LoadConfig() {
            var url = "/api/v1.0/configuration/GetListConfigurations?lancurrent="+this.lancurrent+"&landingpageid=" + this.landingpageid;
            var self = this;
            axios.get<ConfigurationViewModel>(url).then(function (response: AxiosResponse<ConfigurationViewModel>) {
                if (response !== null && response.data !== null) {
                    self.blobs = response.data.blobs ?? [];
                    self.blobsseo = response.data.blobsseo ?? [];
                    self.lastconfigname = response.data.lastconfigname ?? '';
                    self.lastconfigurl = response.data.lastconfigurl ?? '';
                    self.lastconfigicon = response.data.lastconfigicon ?? '';
                    self.lastconfighostname = response.data.lastconfighostname ?? '';
                    self.ReloadTooltips();
                }
            });
        },
        LoadConfigMonitoring(dctoolsbackurl: string) {
            var url = `${dctoolsbackurl}/api/v3.0/RealTimeService/GetListMonitoringConfig`;
            var self = this;
            axios.get<GetMonitoringConfigResponse>(url, {  withCredentials: true }).then(function (response: AxiosResponse<GetMonitoringConfigResponse>) {
                if (response !== null && response.data !== null) {
                    self.configsmon = response.data.Configurations;
                    self.lastconfigicon = response.data.LastConfigIcon;
                   // self.ReloadTooltips();
                }
            });
        },
        isTouchDevice() {
            return 'ontouchstart' in window || (window as any)['DocumentTouch'] && document instanceof (window as any)['DocumentTouch'];
        },
        ReloadTooltips() {
            $("[data-bs-toggle='tooltip']").tooltip('hide');
        this.$nextTick(function () {
            if (!this.isTouchDevice()) {
                var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
                var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
                    return new bootstrap.Tooltip(tooltipTriggerEl)
                });
            }
            else
                $('[data-bs-toggle="tooltip"]').removeAttr("title");
        });
    },
        DCDeleteConfig(idconfiguser: number, machine: number, descconfirm: string) {
            let choice: boolean = confirm(descconfirm);
            if (!choice)
                return;
            let url: string = "/api/v1.0/DetecterConfig/DeleteConfSnap?machine=" + machine + "&idconfiguser=" + idconfiguser;
            let self = this;
            axios.delete<boolean>(url).then(function (response: AxiosResponse<boolean>) {
                if (response.data) {
                    self.LoadConfig();
                }
            });
        },
        DeleteConfig(blob: dccore_configblobview,descconfirm:string) {
            this.DCDeleteConfig(blob.idnum, blob.emp, descconfirm);

        },
        DeleteConfigMon(dctoolsbackurl: string, blob: MonitoringConfigurationViewModel, descconfirm: string) {
            this.DCDeleteConfigMon(dctoolsbackurl, blob.hashid, descconfirm);

        },
        DCDeleteConfigMon(dctoolsbackurl: string, idconfiguser: string, descconfirm: string) {
            let choice: boolean = confirm(descconfirm);
            if (choice == false)
                return;
            let url: string = `${dctoolsbackurl}/api/v3.0/RealTimeService/DeleteConfigMon?idconfiguserstr=${idconfiguser}`;
            let self = this;
            axios.delete<boolean>(url).then(function (response: AxiosResponse<boolean>) {
                if (response.data) {
                    location.reload();
                }
            });
        },
         GetDescSeo(id: number): string {
            for (let blob of this.blobsseo) {
                if (blob.idconfiguser == id)
                    return blob.keywords;
            }
             return this.defaultconfigdesc;
        }
    }

});